module.exports = __webpack_public_path__ + "img/platinumRiver@2x.3aef56c.jpg";